module.exports = __webpack_public_path__ + "media/images/consultorio3-2dcefeaf0a72043b01d61abf3f054f6f.svg";